import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { LOGIN_ACTION, LOGIN_M, LOGOUT_M, SET_ERROR_MESSAGE_M, ROMOVE_ERROR_MESSAGE_M } from '../vuex-types'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    loginUser: null,
    errorMessage: ''
  },
  mutations: {
    [LOGIN_M]: (state, user) => {
      state.isLogin = true
      state.loginUser = user
    },
    [LOGOUT_M]: (state) => { state.isLogin = false },
    [SET_ERROR_MESSAGE_M]: (state, message) => { state.errorMessage = message },
    [ROMOVE_ERROR_MESSAGE_M]: (state) => { state.errorMessage = '' }
  },
  actions: {
    [LOGIN_ACTION]: async ({ commit, state }, ruleForm) => {
      try {
        const res = await axios.post('/user/login', { ...ruleForm })
        commit(LOGIN_M, res.data)
        commit(ROMOVE_ERROR_MESSAGE_M)
        // 跳转到首页
        router.push('/')
      } catch (error) {
        commit(SET_ERROR_MESSAGE_M, error.response.data.message)
      }
    }
  },
  getters: {
    getIsLogin: state => {
      return state.isLogin
    },
    getUser: state => {
      return state.loginUser
    },
    getToken: state => {
      if (state.loginUser !== null && state.loginUser !== undefined && 'token' in state.loginUser) return state.loginUser.token
      else return null
    },
    getUsername: state => {
      if (state.loginUser !== null && state.loginUser !== undefined && 'username' in state.loginUser) return state.loginUser.username
      else return null
    },
    getErrorMessage: state => {
      return state.errorMessage
    }
  },
  modules: {
  }
})
